<template>
  <b-card
    border-variant="light"
    bg-variant="light"
    header="Sign In"
    class="text-center"
  >
    <b-card-body>
      <b-alert :show="error !== ''" variant="danger">{{ error }}</b-alert>
      <b-form-input
        :state="true"
        v-model="userName"
        placeholder="Username or Email"
      ></b-form-input>
      <b-form-text v-if="otpLogin"
        >An email containing OTP will be sent to your registered email
        id</b-form-text
      >
      <b-form-input
        class="mt-4"
        v-if="otpLogin && otpSent"
        :state="true"
        v-model="otp"
        placeholder="Enter OTP"
      ></b-form-input>
      <b-form-input
        class="mt-4"
        v-if="!otpLogin"
        :state="true"
        v-model="password"
        type="password"
        placeholder="Password"
      ></b-form-input>
      <div v-if="otpLogin">
        <br />
        <b-button
          v-if="otpSent"
          variant="success"
          :disabled="!userName || !otp"
          @click="login"
          class="px-4"
          >Login</b-button
        >
        <b-button
          variant="info"
          class="ml-4"
          v-if="otpLogin"
          @click="sendOTP()"
          :disabled="!userName || timeLeft > 0"
          >{{
            otpSent
              ? `Resend OTP ${
                  timeLeft > 0 ? "in " + timeLeft + " seconds" : ""
                }`
              : "Send OTP"
          }}</b-button
        >
      </div>
      <div v-else>
        <br />
        <b-button
          v-if="!isLoading"
          variant="success"
          :disabled="!userName || !password"
          @click="login"
          class="px-4"
          >Login</b-button
        >
        <b-button class="px-4" v-else variant="success" disabled
          >&nbsp;&nbsp; <b-spinner small></b-spinner>&nbsp;&nbsp; </b-button
        >&nbsp;&nbsp;
        <a class="ml-4" href="/forgot-password">Forgot Password</a>
      </div>
      <br />
      <a class="ml-4" @click="showFields(!otpLogin)"
        >Click here to Login with {{ otpLogin ? "Password" : "OTP" }}</a
      >

      <div class="strike my-3">
        <span>or Sign In with</span>
      </div>
      <div class="fb-btn">
        <facebook-login
          ref="fbLogin"
          class="button"
          appId="608206794381098"
          :login-options="{ scope: 'email,user_birthday,user_gender' }"
          @login="onLogin"
          @logout="onLogout"
          @sdk-init="sdkLoaded"
        >
          <template #login>Facebook</template>
        </facebook-login>
      </div>
    </b-card-body>
    <p>
      Don't have an account?
      <router-link to="/signup">Create One</router-link> now!
    </p>
  </b-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  BAlert,
  BCard,
  BCardBody,
  BFormInput,
  BButton,
  BSpinner,
  BFormText,
} from "bootstrap-vue";
import facebookLogin from "vue-facebook-login-component";
import { EventBus } from "../../router/EventBus";

export default {
  name: "SignIn",

  components: {
    BAlert,
    BCard,
    BCardBody,
    BFormInput,
    BButton,
    BSpinner,
    BFormText,
    facebookLogin,
  },

  data() {
    return {
      userName: "",
      password: "",
      otp: "",
      error: "",
      isLoading: false,
      isConnected: false,
      otpSent: false,
      FB: undefined,
      otpLogin: true,
      timeLeft: 0,
      form: {
        name: "",
        username: "",
        password: "",
        email: "",
        dob: "",
        about: "",
        mobile: "",
        gender: "",
      },
    };
  },

  computed: {
    ...mapGetters(["isUserAuthenticated"]),
  },

  created() {
    EventBus.$on("signout", () => {
      this.onLogout();
    });
  },

  methods: {
    ...mapActions(["signIn", "registerUser", "requestOTP"]),

    ...mapMutations(["setUserDetails", "setBookmarkList"]),

    async getUserData() {
      if (this.isConnected) {
        await this.FB?.api(
          "/me",
          "GET",
          {
            fields: "id,name,email,picture,gender,birthday",
          },
          async (user) => {
            this.form.fbId = user.id;
            this.form.email = user.email;
            this.form.username = user.email;
            this.form.name = user.name;
            this.form.dob = user.birthday;
            this.form.gender = user.gender;
            // this.form.picture = user.picture.data.url;

            let res = await this.registerUser({ form: this.form });
            if (res.token) {
              localStorage.setItem("user", JSON.stringify(res));
            }
            this.setUserDetails(res);
            this.setBookmarkList(res.bookmarks);
            this.$emit("cancelled");
            this.$router.push("/home");
          }
        );
      }
    },
    sdkLoaded(payload) {
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData();
    },
    onLogin() {
      this.isConnected = true;
      this.getUserData();
    },
    onLogout() {
      this.isConnected = false;
      this.FB.api("/me/permissions", "delete", null, () => this.FB.logout());
    },
    async sendOTP() {
      this.otpSent = true;
      this.error = "";
      try {
        await this.requestOTP({ username: this.userName });
        this.timeLeft = 60;
        let downloadTimer = setInterval(() => {
          this.timeLeft--;
          if (this.timeLeft <= 0) clearInterval(downloadTimer);
        }, 1000);
      } catch (e) {
        this.otpSent = false;
        this.timeLeft = 0;
        this.error = e.response.data.message;
        console.error(e);
      }
    },
    showFields(isOTPLogin) {
      this.otpLogin = isOTPLogin;
      this.otp = "";
      this.password = "";
    },
    async login() {
      try {
        this.isLoading = true;
        this.error = "";
        await this.signIn({
          username: this.userName,
          password: this.password,
          otp: this.otp,
        });

        if (this.isUserAuthenticated) {
          this.$emit("cancelled");
          this.$router.push({ name: "Home" });
        }
      } catch (e) {
        this.error = e.response.data.message;
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.strike {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
}
.strike > span {
  position: relative;
  display: inline-block;
  color: #8c9093;
}
.strike > span:before,
.strike > span:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 9999px;
  height: 1px;
  background: #8c9093;
}
.strike > span:before {
  right: 100%;
  margin-right: 15px;
}
.strike > span:after {
  left: 100%;
  margin-left: 15px;
}
.fb-btn {
  text-align: -webkit-center;
}
</style>
